
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.6998 6.9998C3.6998 5.17727 5.17727 3.6998 6.9998 3.6998C8.82234 3.6998 10.2998 5.17727 10.2998 6.9998C10.2998 8.82234 8.82234 10.2998 6.9998 10.2998C5.17727 10.2998 3.6998 8.82234 3.6998 6.9998ZM6.9998 2.2998C4.40407 2.2998 2.2998 4.40407 2.2998 6.9998C2.2998 9.59554 4.40407 11.6998 6.9998 11.6998C7.9162 11.6998 8.77133 11.4375 9.49425 10.984C9.49773 10.9876 9.50126 10.9912 9.50483 10.9948L12.0048 13.4948C12.2782 13.7681 12.7214 13.7681 12.9948 13.4948C13.2681 13.2214 13.2681 12.7782 12.9948 12.5048L10.5592 10.0692C11.27 9.24575 11.6998 8.17298 11.6998 6.9998C11.6998 4.40407 9.59554 2.2998 6.9998 2.2998Z","fill":"#10001F"}})])
          )
        }
      }
    